<template>
    <el-dialog
        title="一键设置"
        :visible.sync="accountDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        top="3%"
        width="600px"
        center>
        <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">

            <el-form-item label="社区" prop="xiangmu_id" v-if="[3,5].includes(user.power)" >
                <el-select v-model="accountForm.xiangmu_id" placeholder="请选择社区" filterable style="width: 100%;">
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="限制兑换数量" prop="is_limit">
                <el-switch
                    v-model="accountForm.is_limit" :active-value="1" :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="兑换上限" prop="exchange_num" v-if="accountForm.is_limit === 1">
                <el-input-number style="width: 100%" v-model="accountForm.exchange_num" placeholder="请输入个人兑换上限" :min="1" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="时间范围" prop="exchange_time">
                <el-date-picker
                    style="width: 100%"
                    class="flex-sub"
                    v-model="accountForm.exchange_time"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import {getXiangMuList} from "@/api/common";
import {fastUpdateProduct} from "@/api/weilao";

export default {
    name: "ShoppingOneKeyDialog",
    props: {
        accountDialog: {
            type: Boolean,
            default: false
        },
    },
    data() {

        return {
            power: 0,
            accountForm: {
                xiangmu_id: '',
                is_limit: 1,
                exchange_num: '',
                exchange_time: [],
            },
            projectList: [],
            xiaoqu: [],
            rules: {
                xiangmu_id: [{required: true, message: '请选择社区', trigger: 'change'}],
                exchange_num: [{required: true, message: '请输入个人兑换上限', trigger: 'change'}],
                exchange_time: [{required: true, message: '请选择兑换时间范围', trigger: 'change'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.getXiaoQuList()
    },
    methods: {
        //  获取当前人员下的小区
        async getXiaoQuList() {
            const project = await getXiangMuList()
            this.projectList = project.data
            if (project.data.length) this.accountForm.xiangmu_id =project.data[0].id
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await fastUpdateProduct(
                this.accountForm.xiangmu_id,
                this.accountForm.is_limit,
                this.accountForm.exchange_num,
                this.accountForm.exchange_time[0],
                this.accountForm.exchange_time[1],
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }

    },
    watch: {
    }
}
</script>

<style scoped lang="scss">

</style>
